import {
  HourglassBottomOutlined,
  PendingActionsOutlined,
  ThumbDownAltOutlined,
  ThumbUpAltOutlined,
} from "@mui/icons-material";
import React from "react";
import { lightPalette } from "../mui/palettes";

export const getClientStatusIcon = (status: string) => {
  if (status === "active") {
    return <ThumbUpAltOutlined fill={lightPalette.primary.main} />;
  }
  if (status === "rejected") {
    return <ThumbDownAltOutlined fill={lightPalette.primary.main} />;
  }
  if (status === "pending") {
    return <PendingActionsOutlined fill={lightPalette.primary.main} />;
  }
  return <HourglassBottomOutlined fill={lightPalette.primary.main} />;
};
